import { Platform } from 'react-native'

const defaults = {
  width: {
    default: 810,
    web: 1080,
  },
  height: {
    default: 1080,
    web: 1920,
  },
}

const widthDefault = Platform.select({
  default: defaults.width.default,
  web: defaults.width.web,
})

const heightDefault = Platform.select({
  default: defaults.height.default,
  web: defaults.height.web,
})

const gap = Platform.select({
  default: 32,
  web: 32,
})

const padding = Platform.select({
  default: 64,
  web: 64,
})

const borderRadius = Platform.select({
  default: 32,
  web: 32,
})

const topbar = {
  height: Platform.select({
    default: 96,
    web: 96,
  }),
}

const header = {
  height: Platform.select({
    default: 176, // 190
    web: 192, // 190 + 64,
  }),
  description: {
    maxWidth: 682, // defaults.width.default - 2 * padding,
  },
}

const tileSmall = {
  height: 112,
}

const intro = {
  height: topbar.height,
}

const buttonsFixed = {
  height: 2 * padding + 48,
}

export {
  defaults,
  widthDefault,
  heightDefault,
  gap,
  padding,
  borderRadius,
  topbar,
  header,
  tileSmall,
  intro,
  buttonsFixed,
}
